type MonthYearDateMaskFactory = ((value?: string) => string) & {
    patterns: {
        M: {
            pattern: RegExp;
        };
        N: {
            pattern: RegExp;
        };
    };
};

export const MonthYearDateMask: MonthYearDateMaskFactory = Object.assign(
    (value: string = '') => {
        const numericValue = ((value || '').match(/\d/g) || []).join('');
        const monthFirstDigit = numericValue.charAt(0);

        if (monthFirstDigit === '0') {
            MonthYearDateMask.patterns.N.pattern = /[1-9]/;
        } else if (monthFirstDigit === '1') {
            MonthYearDateMask.patterns.N.pattern = /[0-2]/;
        } else {
            MonthYearDateMask.patterns.N.pattern = /\d/;
        }

        return 'MN/0000';
    },
    {
        patterns: {
            M: {
                pattern: /[0-1]/,
            },
            N: {
                pattern: /\d/,
            },
        },
    }
);
